import { action, extendObservable } from 'mobx';
import orderBy from 'lodash/orderBy';
import pickBy from 'lodash/pickBy';
import get from 'lodash/get';
import FetchService from '../../../core/services/FetchService';
import UsageStatsFilterService from './UsageStatsFilterService';
import FormService from '../../../core/services/FormService';

class UsageStatsStudentListDialogService {
  form = new FormService();
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      show: false,
      companyId: '',
      students: [],
    });
  }

  handleShow = action((companyId) => {
    this.form.setInitialValues({});
    this.companyId = companyId;

    this.fetch
      .fetch({
        url: `/reports/usage-stats/companies/${companyId}/details`,
        query: {
          ...(UsageStatsFilterService.form.getValue('from') && {
            from: UsageStatsFilterService.form.getValue('from').format('YYYY-MM-DD'),
          }),
          ...(UsageStatsFilterService.form.getValue('to') && {
            to: UsageStatsFilterService.form.getValue('to').format('YYYY-MM-DD'),
          }),
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.students = orderBy(this.fetch.data, 'name', 'asc');
        } else {
          this.students = [];
        }
        this.show = true;
      });
  });

  handleClose = action(() => {
    this.show = false;
    this.companyId = '';
    this.students = [];
  });

  handleFilter = action(() => {
    this.students = orderBy(
      this.fetch.data.filter((s) => {
        return Object.keys(pickBy(this.form.getValues(), (x) => !!x)).reduce((acc, key) => {
          return (
            acc &&
            get(s, { academicPlan: 'academicPlan.id', school: 'school.id' }[key] || key, '') === this.form.getValue(key)
          );
        }, true);
      }),
      'name',
      'asc'
    );
  });
}

const usageStatsStudentListDialogService = new UsageStatsStudentListDialogService();

export default usageStatsStudentListDialogService;
